// extracted by mini-css-extract-plugin
export var dropdown = "_sv-0";
export var imageWrapper = "_sv-3";
export var itemNameContainer = "_sv-1";
export var productImage = "_sv-2";
export var spinnerWrapper = "_sv-4";